<template>
	<div class="basic_wrap">
		<bsHeader :title="$t('user.userInfo')" @backurl="$router.back()"></bsHeader>

		
		<div class="top_wrap">
			<div class="head_img">
				<img :src="user.user_icon" alt="" srcset="">
				<p>{{ user.username }}</p>
			</div>
			<!-- <div class="info" v-show="false">
				<van-cell-group inset>
					<van-field v-model="info.email" :label="$t('user.infoEmail')"
						:placeholder="$t('user.infoEmailPlace')" />
					<van-field v-model="info.telegram" :label="$t('user.infoTg')" :placeholder="$t('user.infoTgPlace')" />
					<van-field v-model="info.whatsapp" :label="$t('user.infoWs')" :placeholder="$t('user.infoWsPlace')" />
				</van-cell-group>
			</div> -->

			<div class="block_div list">
				<van-cell is-link @click="clickCell(0)">
					<template #title>
						<span class="custom-title">{{ $t('user.txt1') }}</span>
					</template>
				</van-cell>
				<van-cell is-link @click="clickCell(1)">
					<template #title>
						<span class="custom-title">{{ $t('user.txt2') }}</span>
					</template>
				</van-cell>
				<van-cell is-link @click="clickCell(2)" v-show="false">
					<template #title>
						<span class="custom-title">{{ $t('user.txt3') }}</span>
					</template>
				</van-cell>
				<van-cell is-link @click="clickCell(3)">
					<template #title>
						<span class="custom-title">{{ $t('user.txt4') }}</span>
					</template>
				</van-cell>
				<van-cell is-link @click="clickCell(4)">
					<template #title>
						<span class="custom-title">{{ $t('user.txt5') }}</span>
					</template>
				</van-cell>
			</div>
			<!-- <div v-show="false" class="basic_btn btn" @click="updataPass(index)">
				{{ $t('user.save') }}
			</div> -->
		</div>
		<div class="auto_box">
			<div class=" desc_warp">
				<!-- <img src="../img/user/certification.png" /> -->
				<!-- <p>{{ $t('auth.authSafe') }}</p> -->
				<p></p>
				<p>{{ $t('auth.authTips1') }}</p>
			</div>
			<div class="item_warp">
				<div v-show="data.auth_phone_status" class="block_div flex_center item">
					<div class="flex_center item_info">
						<div>
							<img src="../img/user/phone.png">
						</div>
						<div>
							<p>{{ $t('auth.authPhone') }}</p>
							<p v-if="!bind_phone">{{ $t('auth.bindPhone') }}</p>
							<p v-if="bind_phone">{{ phone }}</p>
						</div>
					</div>
					<div>
						<p v-if="bind_phone" class="btn_0">{{ $t('auth.authed') }}</p>
						<p v-if="!bind_phone" class="btn_1 basic_btn" @click="$router.replace('/authPhone')">
							{{ $t('auth.toAuth') }}</p>
					</div>
				</div>
				<div v-show="data.auth_email_status" class="block_div flex_center item">
					<div class="flex_center item_info">
						<div>
							<img src="../img/user/email.png">
						</div>
						<div>
							<p>{{ $t('auth.authEmail') }}</p>
							<p v-if="!bind_email">{{ $t('auth.bindEmail') }}</p>
							<p v-if="bind_email">{{ email }}</p>
						</div>
					</div>
					<div>
						<p v-if="bind_email" class="btn_0">{{ $t('auth.authed') }}</p>
						<p v-if="!bind_email" class="btn_1 basic_btn" @click="$router.replace('/authEmail')">
							{{ $t('auth.toAuth') }}</p>
					</div>
				</div>
				<div v-show="data.auth_authenticator_status" class="block_div flex_center item">
					<div class="flex_center item_info">
						<div>
							<img src="../img/user/authenticator.png">
						</div>
						<div>
							<p>{{ $t('auth.authAuthenticator') }}</p>
							<p v-if="!bind_authenticator">{{ $t('auth.bindAuthenticator') }}</p>
							<p v-if="bind_authenticator">{{ authenticator }}</p>
						</div>
					</div>
					<div>
						<p v-if="bind_authenticator" class="btn_0">{{ $t('auth.authed') }}</p>
						<p v-if="!bind_authenticator" class="btn_1 basic_btn" @click="$router.replace('/authGoogle')">
							{{ $t('auth.toAuth') }}</p>
					</div>
				</div>
			</div>
		</div>


		<!-- 修改密码弹出框 -->
		<van-popup class="loginModel" v-model="showChangePass" closeable round :style="{ width: '90%' }">

			<div class="phoneLogin">
				<div class="title">{{ passTitle }}</div>
				<!-- <div class="phoneInputBox"> <input type="text" class="phoneInput" v-model="params.oldpassword"
						:placeholder="$t('user.txt6')" />
				</div> -->
				<div class="phoneInputBox"> <input type="text" class="phoneInput" v-model="params.password"
						:placeholder="$t('user.txt7')" />
				</div>
				<div class="phoneInputBox"> <input disabled type="text" class="phoneInput" v-model="email"
						:placeholder="$t('login.email')" />
				</div>
				<!-- 验证邮箱 -->
				<div class="input_box_email">
					<div class="input_send_box"><input v-model.trim="params.email_code" type="text" class="input_main"
							:placeholder="$t('login.txt4')" />

						<div class="input_send">
							<van-count-down :time="time" class="btn get_captcha" @finish="timeCall">
								<template v-slot="timeData">
									<span @click="sendcode">{{
										timeData.seconds > 0
										? timeData.seconds
										: $t('auth.sendEmailCode')
									}}</span>
								</template>
							</van-count-down>
						</div>
					</div>
				</div>
				<!-- 绑定按钮 -->
				<div class="bindBtnBox">

					<van-button class="bindBtn" type="primary" @click="updataPass(0)" block>{{
						$t('user.save')
					}}</van-button>
				</div>
			</div>
		</van-popup>
		<!-- 修改提款密码弹出框 -->
		<van-popup class="loginModel" v-model="showTiKuanPass" closeable round :style="{ width: '90%' }">

			<div class="phoneLogin">
				<div class="title">{{ passTitle }}</div>
				<!-- <div class="phoneInputBox"> <input type="text" class="phoneInput" v-model="params.oldpassword"
			:placeholder="$t('user.txt6')" />
	               </div> -->
				<div class="phoneInputBox"> <input type="text" class="phoneInput" v-model="params.password"
						:placeholder="$t('user.txt7')" />
				</div>
				<div class="phoneInputBox"> <input disabled type="text" class="phoneInput" v-model="email"
						:placeholder="$t('login.email')" />
				</div>
				<!-- 验证邮箱 -->
				<div class="input_box_email">
					<div class="input_send_box"><input v-model.trim="params.email_code" type="text" class="input_main"
							:placeholder="$t('login.txt4')" />

						<div class="input_send">
							<van-count-down :time="time" class="btn get_captcha" @finish="timeCall">
								<template v-slot="timeData">
									<span @click="sendcode">{{
										timeData.seconds > 0
										? timeData.seconds
										: $t('auth.sendEmailCode')
									}}</span>
								</template>
							</van-count-down>
						</div>
					</div>
				</div>
				<!-- 绑定按钮 -->
				<div class="bindBtnBox">

					<van-button class="bindBtn" type="primary" @click="updataPass(1)" block>{{
						$t('user.save')
					}}</van-button>
				</div>
			</div>
		</van-popup>




		<!-- 修改邮箱 -->
		<van-popup class="loginModel" v-model="showEmail" closeable round :style="{ width: '90%' }">

			<div class="phoneLogin">
				<div class="phoneInputBox"> <input type="text" class="phoneInput" v-model="info.email"
						:placeholder="$t('user.infoEmailPlace')" />
				</div>
				<!-- 绑定按钮 -->
				<div class="bindBtnBox">
					<van-button :disabled="isDisavled" class="bindBtn" type="primary" @click="updataPass(2)" block>{{
						$t('user.save')
					}}</van-button>
				</div>
			</div>
		</van-popup>
		<!-- 修改飞机 -->
		<van-popup class="loginModel" v-model="showTele" closeable round :style="{ width: '90%' }">

			<div class="phoneLogin">
				<div class="phoneInputBox"> <input type="text" class="phoneInput" v-model="info.telegram"
						:placeholder="$t('user.infoTgPlace')" />
				</div>
				<!-- 绑定按钮 -->
				<div class="bindBtnBox">
					<van-button :disabled="isDisavled" class="bindBtn" type="primary" @click="updataPass(3)" block>{{
						$t('user.save')
					}}</van-button>
				</div>
			</div>
		</van-popup>
		<!-- 修改ws -->
		<van-popup class="loginModel" v-model="showWs" closeable round :style="{ width: '90%' }">

			<div class="phoneLogin">
				<div class="phoneInputBox"> <input type="text" class="phoneInput" v-model="info.whatsapp"
						:placeholder="$t('user.infoWsPlace')" />
				</div>
				<!-- 绑定按钮 -->
				<div class="bindBtnBox">
					<van-button :disabled="isDisavled" class="bindBtn" type="primary" @click="updataPass(4)" block>{{
						$t('user.save')
					}}</van-button>
				</div>
			</div>
		</van-popup>

		<!-- 绑定提款密码 -->
		<van-popup class="loginModel" v-model="showBindPayPass" closeable round :style="{ width: '90%' }">

			<div class="phoneLogin">
				<div class="title">{{ passTitle }}</div>
				<!-- <div class="phoneInputBox"> <input type="text" class="phoneInput" v-model="params1.oldpassword"
			:placeholder="$t('user.txt6')" />
	            </div> -->
				<div class="phoneInputBox"> <input type="text" class="phoneInput" v-model="params.password"
						:placeholder="$t('user.txt11')" />
				</div>

				<!-- 绑定按钮 -->
				<div class="bindBtnBox">

					<van-button :disabled="isDisavled" class="bindBtn" type="primary" @click="updataPass(1)" block>{{
						$t('user.save')
					}}</van-button>
				</div>
			</div>
		</van-popup>

	</div>
</template>

<script>
import Vue from 'vue';
import bsHeader from '../../components/bsHeader.vue'
import Fetch from '../../utils/fetch'
import {
	Field, CellGroup
} from "vant";

import {
	CountDown,
	Checkbox,
	Dialog,
	DropdownMenu,
	DropdownItem,
	Popup
} from "vant";
Vue.use(CountDown).use(Checkbox).use(Dialog).use(DropdownMenu).use(DropdownItem).use(Popup);
Vue.use(Field).use(CellGroup);
export default {
	name: "info",
	components: {
		bsHeader
	},
	data() {
		return {
			user: [],
			showChangePass: false,
			showTiKuanPass: false,
			showChangeTele: false,
			showEmail: false,
			showTele: false,
			showWs: false,
			isDisavled: false,
			passTitle: "",
			time: 0,
			is_send: false,
			info: {
				telegram: '',
				email: '',
				whatsapp: ''
			},
			params: {
				oldpassword: '',
				password: '',
				email_code: ''
			},
			params1: {
				// oldpassword: '',
				password: '',
			},
			paramsTiKuanPass: {
				oldpassword: '',
				password: '',
			},
			email: '',
			paypwd: "",
			showBindPayPass: false,
			data: {},
			bind_phone: true,
			bind_email: true,
			bind_authenticator: true,
			phone: this.$t('auth.bindPhone'),
			email: this.$t('auth.bindEmail'),
			authenticator: this.$t('auth.bindAuthenticator')

		};
	},
	created() {
		if (window.plus) {
			plus.navigator.setStatusBarBackground('#FFFFFF');
			plus.navigator.setStatusBarStyle('dark');
		}
		this.$parent.footer('user', false);
	},
	mounted() {
		this.start();
		this.startauth();
	},
	methods: {
		startauth() {
			Fetch('/user/getAuthStatus').then((r) => {
				this.data = r.data;
				this.bind_phone = r.data.auth_phone;
				this.phone = r.data.phone;
				this.bind_email = r.data.auth_email;
				this.email = r.data.email;
				this.bind_authenticator = r.data.auth_authenticator;
				this.authenticator = r.data.authenticator_key;
			});
		},
		start() {
			Fetch('/user/getUserInfo').then(r => {
				this.user = r.data;
				this.info.email = r.data.email;
				this.email = r.data.email;
				this.info.telegram = r.data.telegram;
				this.info.whatsapp = r.data.whatsapp;
				//判断paypwd是否为空
				this.paypwd = r.data.paypwd;
				if (this.paypwd == null || this.paypwd == '') {
					this.passTitle = this.$t('login.txt11');
					this.showBindPayPass = true;

				}
			})
		},
		submit() {
			this.isDisavled = true;
			Fetch('/user/setUserInfo', {
				...this.info,
			}).then(r => {
				this.$router.replace('/user');
				this.isDisavled = false;
			})
		},
		clickCell(index) {
			this.start();
			switch (index) {
				case 0:
					this.passTitle = this.$t('user.txt1');
					this.showChangePass = true;
					break;
				case 1:
					this.passTitle = this.$t('user.txt2');
					this.showTiKuanPass = true;
					break;
				case 2:
					this.showEmail = true;
					break;
				case 3:
					this.showTele = true;
					break;
				case 4:
					this.showWs = true;
					break;
				default:
					break;
			}
		},
		updataPass(index) {
			if (index == 0) {
				// if (this.params.oldpassword == "") {
				// 	this.$toast(this.$t('user.txt9'));
				// 	return;
				// }
				if (this.params.password == "") {
					this.$toast(this.$t('user.txt10'));
					return;
				}
				Fetch('/user/editPassword', {
					...this.params,
				}).then(r => {
					this.showChangePass = false;
					this.params.oldpassword = '';
					this.params.password = '';



					this.$router.replace('/user');
				})
			} else if (index == 1) {
				// if (this.params1.oldpassword == "") {
				// 	this.$toast(this.$t('user.txt9'));
				// 	return;
				// }
				if (this.params.password == "") {
					this.$toast(this.$t('user.txt10'));
					return;
				}
				Fetch('/user/editpayPassword', {
					...this.params,
				}).then(r => {
					this.showTiKuanPass = false;
					this.params.oldpassword = '';
					this.params.password = '';

					this.$router.replace('/user');
				})
			}
			else if (index == 2) {

				this.isDisavled = true;
				Fetch('/user/setUserInfo', {
					...this.info,
				}).then(r => {

					this.isDisavled = false;
					this.$router.replace('/user');
				})
			} else if (index == 3) {
				Fetch('/user/setUserInfo', {
					...this.info,
				}).then(r => {
					this.$router.replace('/user');
				})
			} else if (index == 4) {
				this.isDisavled = true;
				Fetch('/user/setUserInfo', {
					...this.info,
				}).then(r => {
					this.$router.replace('/user');

				})
			}

		},
		timeCall() {
			this.is_send = false;
			this.time = 0;
		},
		sendcode() {
			if (this.is_send) {
				return false;
			}
			if (!this.email) {
				this.$toast(this.$t('auth.emailEmpty'));
				return false;
			}
			var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
			if (!reg.test(this.email)) {
				this.$toast(this.$t('auth.emailError'));
				return false;
			}
			this.is_send = true;

			Fetch("/index/getEmailCode", {
				email: this.email
			}).then(() => {
				this.time = 60 * 1000;
				this.$toast({
					background: "#07c160",
					message: this.$t('auth.sendsuccess'),
				});
			}).catch(() => {
				this.is_send = false;
			});
		},

	}
};
</script>

<style lang="less" scoped>
.van-count-down {
	color: white !important;
}

.top_wrap {
	margin-top: 54px;
}

.list {
	margin-top: 10px;

	img {
		vertical-align: middle;
		height: 24px;
		width: 22px;
		margin-right: 10px;
	}

	span {
		font-size: 14px;
	}
}

.head_img {
	padding: 30px 0;
	text-align: center;
	background: #FFF;
	margin-bottom: 15px;

	img {
		width: 20%;
		margin-bottom: 15px;
	}

	p {
		font-size: 18px;
	}
}

.info {
	background: #FFF;
}

.btn {
	position: fixed;
	bottom: 30px;
}

.loginModel {
	background: white;
	box-sizing: border-box;
	text-align: center;
	color: #ffffff;
	-webkit-border-radius: 10px;
	-moz-border-radius: 10px;
	border-radius: 10px;
	padding: 0 28px;
	padding-top: 42px;
	padding-bottom: 28px;
}

.phoneLogin {
	.title {
		color: #0A0A27;
		font-weight: bold;
		font-size: 18px;
		text-align: center;
	}

	.phoneInputBox {
		.phoneInput {
			width: 100%;
			border-radius: 4px;
			background: none;
			background: #F5F6F8;
			height: 60px;
			border: 0px;
			line-height: 60px;
			padding-left: 16px;
			outline: none;
			margin-top: 20px;
			font-size: 14px;
			color: #0A0A27;
		}

		input::placeholder {
			font-weight: bold;
			opacity: 0.5;
			color: #333;
		}
	}


	.codeBox {
		display: flex;
		justify-content: space-between;
		margin-top: 20px;

		.codeInput {
			border-radius: 4px;
			background: none;
			background: #F5F6F8;
			height: 60px;
			border: 0px;
			line-height: 60px;
			padding-left: 16px;
			outline: none;
			font-size: 14px;
			color: #0A0A27;
			width: 100%;

			::-webkit-input-placeholder {
				color: #333333;
				font-size: 12px;
			}
		}

		.pic1 {
			margin-left: 8px;
			width: 130px;
		}

	}

	.bindBtnBox {

		.bindBtn {
			height: 38px;
			border-radius: 100px;
			margin-top: 44px;
			border-radius: 4px;
			background: #326CF6;

			.van-button__text {
				font-size: 14px;
				font-weight: 400;
				color: white;
			}
		}
	}

	.input_box_email {
		margin-top: 20px;

		.input_send_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			height: 60px;
			background: #F5F6F8;
			margin-top: 15px;
			border-radius: 8px;


			.input_main {
				width: 100%;
				border-radius: 4px;
				background: none;
				height: 60px;
				border: 0px;
				line-height: 60px;
				padding-left: 16px;
				outline: none;
				font-size: 14px;
				color: #0A0A27;
			}

			input::placeholder {
				font-weight: bold;
				opacity: 0.5;
				color: #333;
			}


			.input_send {
				height: 100%;
				width: 150px;
				display: flex;
				justify-content: center;
				align-items: center;
				background-color: #326CF6;
				border-radius: 0 8px 8px 0;
				color: white;
				font-size: 12px;
			}


		}

	}


	.btn {
		position: inherit;
	}
}



.van-button--primary {
	border: none !important;
}

.desc_warp {
	margin-top: 20px;
	text-align: center;

	img {
		width: 100px;
		height: 100px;
	}

	p:nth-child(2) {
		font-size: 20px;
		font-weight: bold;
		margin: 20px 0;
	}

	p:nth-child(3) {
		font-size: 14px;
		color: #999;
		line-height: 1.5;
		padding: 0 20px;
	}
}

.item_warp {
	margin-top: 30px;

	.item {
		margin-bottom: 10px;
		padding: 30px 20px;
		justify-content: space-between;


		.item_info {
			div:nth-child(1) {
				img {
					width: 40px;
				}
			}

			div:nth-child(2) {
				margin-left: 15px;
				line-height: 1.5;

				p:nth-child(1) {
					font-size: 16px;
					font-weight: bold;
				}

				p:nth-child(2) {
					color: #999;
				}
			}
		}

		.btn_0 {
			color: #999;
		}

		.btn_1 {
			font-size: 14px;
			height: unset;
			line-height: unset;
			width: unset;
			border-radius: 14px;
			padding: 5px 10px;
			margin-left: unset;
		}
	}
}
</style>
